/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfSurfaceCH4 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Surface Methane (CH4)",
            service: CorsAnywhere + "http://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_ch4_surface",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>Methane is the second most important human emitted greenhouse gas which contribute significantly to
                climate change. One can observe methane hot spots color-coded in red on the data layer. Data is taken
                from Copernicus Sentinel-5P that is particularly dedicated to monitor Earth atmosphere and produce
                global maps of two atmospheric gases that have high impact on heating up our planet: methane and ozone.
                Carbon dioxide is more abundant in the atmosphere and often associated with global warming. But methane
                is 30 times more potent as heat-trapping gas than carbon dioxide. It enters the atmosphere mainly from
                the fossil fuel industry, landfill sites, livestock farming, rice agriculture and wetlands.</p>
            <p>Text source: Satellite-derived methane hotspot emission estimates using a fast data-driven method, Atmos.
                Chem. Phys., 17, 5751–5774, 2017</p>
            <p><a
                href="https://www.esa.int/Our_Activities/Observing_the_Earth/Copernicus/Sentinel-5P/Methane_and_ozone_data_products_from_Copernicus_Sentinel-5P"
                target="_blank" rel="noopener noreferrer">Read more here.</a></p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_ch4_surface&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                ppbv (parts per billion by volume)
            </p>
        </div>);
    }
}
